import React from "react";
import styled from "styled-components";
import { useOutlet } from "reconnect.js";
import BaseSection from "../BaseSection";
import nft from "../../Utils/Nft";
import * as AppActions from "../../AppActions";
import * as ErrorHandler from "../Error";
import Constants from "../../Constants";
import useScrollBreakpoint from "../../Hooks/useBreakPoint";
import { MenuAltLeft } from "@styled-icons/boxicons-regular/MenuAltLeft";
import { MenuAltRight } from "@styled-icons/boxicons-regular/MenuAltRight";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function Navbar(props) {
  const {
    hideButtons = typeof window !== "undefined"
      ? window.screen.width < 800
      : true,
  } = props;
  const [updateCnt, setUpdateCnt] = useOutlet("update-counter");
  const { passBreakpoint } = useScrollBreakpoint(300);
  const [mobileMenuVisible, setMobileMenuVisible] = React.useState(false);
  const lang = props.lang;

  const forceUpdate = React.useCallback(async () => {
    await nft.loadContractInfo();
    setUpdateCnt((cnt) => cnt + 1);
  }, [setUpdateCnt]);

  async function onConnectClick() {
    if (ErrorHandler.handleGlobalError()) {
      return;
    }

    AppActions.setLoading(true);
    await delay(500);
    try {
      await nft.connect();
      // let it show address directly
      setUpdateCnt((cnt) => cnt + 1);
      // then reload the contract info
      forceUpdate();
    } catch (ex) {
      console.warn(ex);
    }
    AppActions.setLoading(false);
  }

  function scrollTo(sectionId, evt) {
    evt.preventDefault();
    const elem = document.getElementById(sectionId);
    if (elem) {
      const top = elem.offsetTop;
      window.scrollTo({ top: top - 60, behavior: "smooth" });
    }
    setMobileMenuVisible(false);
  }

  const getSocialLinks = () => (
    <>
      <a
        href="/#welcome"
        className="link-item"
        alt="link-item"
        onClick={scrollTo.bind(null, "about")}
      >
        {lang === "tw" ? "介紹" : "Introduction"}
      </a>

      <p style={{ height: "100%", display: !hideButtons ? "default" : "none" }}>
        |
      </p>

      <a
        href="/#"
        className="link-item"
        alt="link-item"
        onClick={scrollTo.bind(null, "roadmap")}
      >
        {lang === "tw" ? "延伸" : "Extension"}
      </a>
      <p style={{ height: "100%", display: !hideButtons ? "default" : "none" }}>
        |
      </p>
      <a
        href="/#"
        className="link-item"
        alt="link-item"
        onClick={scrollTo.bind(null, "team")}
      >
        {lang === "tw" ? "團隊" : "Team"}
      </a>
      <p style={{ height: "100%", display: !hideButtons ? "default" : "none" }}>
        |
      </p>
      <a
        href="/#social"
        className="link-item"
        alt="link-item"
        onClick={scrollTo.bind(null, "social")}
      >
        {lang === "tw" ? "聯絡" : "Contact"}
      </a>
            <p style={{ height: "100%", display: !hideButtons ? "default" : "none" }}>
        |
      </p>
      <a
        href="https://revnft-demo.revtel2.com/"
        className="link-item"
        alt="link-item"
      style={{color:'red', backgroundColor:'#eeeeee', padding:5,borderRadius:5}}
      >
        {lang === "tw" ? "DEMO" : "DEMO"}
      </a>

    </>
  );

  return (
    <>
      <Header passBreakpoint={passBreakpoint}>
        <div
          className="content"
          style={{ flexDirection: "row", display: "flex" }}
        >
          <a onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            <img
              src="/logo.png"
              width="150"
              onClick={() => AppActions.navigate("/")}
            />
          </a>

          <div style={{ flex: 1 }} />

          {!hideButtons && getSocialLinks()}
          {hideButtons && (
            <MenuAltRight
              className="mobile-menu-btn"
              size={32}
              color="grey"
              onClick={() => setMobileMenuVisible(true)}
            />
          )}
        </div>
      </Header>

      <Placeholder />

      <MobileBackdrop
        visible={mobileMenuVisible}
        onClick={() => setMobileMenuVisible(false)}
      />

      <MobileMenu visible={mobileMenuVisible}>{getSocialLinks()}</MobileMenu>
    </>
  );
}

const Placeholder = styled.div`
  height: 72px;
  background-color: white;
`;

const MobileMenu = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 240px;
  background-color: white;
  padding: 15px;
  z-index: 1100;
  transform: ${(props) =>
    props.visible ? "translateX(0)" : "translateX(-250px)"};
  transition: all 200ms;
  display: flex;
  flex-direction: column;

  & .link-item {
    font-size: 2rem;
    margin: 20 0px;
    color: #240848;
  }
`;

const MobileBackdrop = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${(props) =>
    props.visible ? "rgba(0, 0, 0, 0.7)" : "transparent"};
  pointer-events: ${(props) => (props.visible ? "normal" : "none")};
  z-index: 1000;
  transition: all 200ms;
`;

const Header = styled(BaseSection)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  box-shadow: ${(props) =>
    props.passBreakpoint ? "0 4px 10px rgba(99, 99, 99, 0.5)" : "transparent"};
  transition: all 200ms;
  z-index: 500;

  & > .content {
    height: 72px;

    & > h2 {
      font-size: 2.5rem;
      cursor: pointer;
      color: #240848;
    }

    & > .link-item {
      font-size: 1.2rem;
      margin: 0 20px;
      color: #240848;
    }
  }

  & .mobile-menu-btn {
    display: none;
    cursor: pointer;
  }

  @media (max-width: 720px) {
    & .mobile-menu-btn {
      display: inline-block;
    }

    & .content {
      flex-direction: row;

      & > .link-item {
        display: none;
      }
    }
  }
`;

export default Navbar;
